module.exports = {
    "id": "projectile",
    "color": "pink",
    "title": "projectile",
    "info": [
        {
            "text": "Turn a piece into a projectile.  It will be launched from a piece of your choice",
            "image": "provision/glitches/projectile/projectile.gif"
        }
    ],
    "category": "keyboard",
    "icon": "target",
    "exposedVariables": [
        {
            "spriteName": "$glitch_target",
            "variableName": "projectile source",
            "tooltip":"Set the sprite that will launch this piece as a projectile",
            "input": {
                "type": "sprite",
                "options": [],
                "min": -999,
                "max": 999
            },
            "value": "none"
        },
        {
            "spriteName": "$glitch_target",
            "variableName": "speed",
            "tooltip":"Set the speed of the projectile",
            "input": {
                "type": "slider",
                "options": [],
                "min": "-20",
                "max": "20",
                "step": ".01"
            },
            "value": "5"
        },
        {
            "spriteName": "$glitch_target",
            "variableName": "distance to travel",
            "tooltip":"Set the distance the projectile will travel before disappearing",
            "input": {
                "type": "slider",
                "options": [],
                "min": "0",
                "max": "480",
                "step": "1"
            },
            "value": "200"
        },
        {
            "spriteName": "$glitch_target",
            "variableName": "trigger key",
            "tooltip":"Set the keyboard key that will launch the projectile",
            "input": {
                "type": "key",
                "options": [],
                "min": -999,
                "max": 999
            },
            "value": "space"
        },
        {
            "spriteName": "$glitch_target",
            "variableName": "cooldown",
            "tooltip":"Set the amount of time between launches",
            "input": {
                "type": "slider",
                "options": [],
                "min": "0",
                "max": "10",
                "step": ".01"
            },
            "value": ".1"
        },
        {
            "spriteName": "$glitch_target",
            "variableName": "shoot automatically",
            "tooltip":"Set whether the projectile will shoot automatically",
            "input": {
                "type": "option",
                "options": [
                    {
                        "value": "false",
                        "label": "false"
                    },
                    {
                        "value": "true",
                        "label": "true"
                    }
                ],
                "min": -999,
                "max": 999
            },
            "value": "false"
        }
    ],
    "codeImage": "provision/glitches/balloon/balloon.png",
    "code": null,
    "zip": null,
    "sb3": null,
    "isRemix": true
};